module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG4eabb1c450dd05fab43a6611d79843a9.4eabb1c4.png";